import { render } from "./VideocallFlow.vue?vue&type=template&id=9af8ea84"
import script from "./VideocallFlow.vue?vue&type=script&lang=js"
export * from "./VideocallFlow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__